/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import React, { Component, Fragment } from "react";
import { Fallback } from "./Fallback";
export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fallback: false,
            error: new Error(),
        };
    }
    static getDerivedStateFromError(e) {
        return {
            fallback: true,
            error: e,
        };
    }
    render() {
        var _a;
        if (this.state.fallback) {
            const Component = (_a = this.props.Fallback) !== null && _a !== void 0 ? _a : Fallback;
            return (React.createElement(Component, { message: this.state.error.message, eventTracker: this.props.eventTracker, eventTitle: this.props.eventTitle }));
        }
        else {
            return React.createElement(Fragment, null, this.props.children);
        }
    }
}
